import React from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import PageView from 'src/components/PageView/PageView';
import { useAnalytics } from 'src/sdk/analytics/AnalyticsContext';
import { makePrivateStackIntroPathname } from 'src/sdk/PATHS';
import { ReachedIntroStepSchema } from 'src/sdk/schemas';
import messages from '../Intro.messages'

const MinRows: React.FC = (props) => {

  const params = useParams();
  const analytics = useAnalytics();

  return (
    <>
      <Helmet defer={false}>
        <title>Intro - Minimum # of rows</title>
        <meta
          name="description"
          content="Instructions on how to make a stack. Make sure to have at least 3 rows"
        />
      </Helmet>
      <PageView
        onPageView={() => analytics.page({
          name: 'MinRows',
          category: 'Intro'
        })}
      />
      <div className="uppercase-label fadeInFromRight">
        Intro
      </div>
      <h1 className="fadeInFromRight second">
        <FormattedMessage
          {...messages.minRowsHeading}
        />
      </h1>
      <p className="fadeInFromRight third">
        <FormattedMessage
          {...messages.minRowsBody}
        />
      </p>
      <Link
        to={{
          pathname: makePrivateStackIntroPathname({
            ...params,
            stepId: ReachedIntroStepSchema.enum.maxRows
          }),
        }}
        className="btn btn-primary"
      >
        <FormattedMessage
          {...messages.nextButtonLabel}
        />
      </Link>
    </>
  );
}

export default MinRows
